import { createTheme, ThemeOptions } from '@mui/material';

export type AppThemeMode = 'system' | 'light' | 'dark' | 'tech';

export type ResolvedThemeMode = 'light' | 'dark' | 'tech';

const getDesignTokens = (mode: ResolvedThemeMode): ThemeOptions => ({
  palette:
    mode === 'light'
      ? {
          mode: 'light',
          primary: {
            main: '#2563eb',
            light: '#60a5fa',
            dark: '#1d4ed8',
          },
          secondary: {
            main: '#7c3aed',
            light: '#a78bfa',
            dark: '#6d28d9',
          },
          background: {
            default: '#f8fafc',
            paper: '#ffffff',
          },
          text: {
            primary: '#0f172a',
            secondary: '#475569',
          },
        }
      : mode === 'dark'
        ? {
            mode: 'dark',
            primary: {
              main: '#60a5fa',
              light: '#93c5fd',
              dark: '#2563eb',
            },
            secondary: {
              main: '#c084fc',
              light: '#d8b4fe',
              dark: '#9333ea',
            },
            background: {
              default: '#020617',
              paper: '#0f172a',
            },
            text: {
              primary: '#e2e8f0',
              secondary: '#94a3b8',
            },
          }
        : {
            mode: 'dark',
            primary: {
              main: '#38bdf8',
              light: '#7dd3fc',
              dark: '#0ea5e9',
            },
            secondary: {
              main: '#a855f7',
              light: '#c084fc',
              dark: '#7e22ce',
            },
            background: {
              default: '#050816',
              paper: '#0b1120',
            },
            text: {
              primary: '#e0f2fe',
              secondary: '#a5b4fc',
            },
          },
  typography: {
    fontFamily: "'Poppins', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 500,
    },
    h5: {
      fontWeight: 500,
    },
    h6: {
      fontWeight: 500,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          scrollBehavior: 'smooth',
          transition: 'all 0.3s',
          backgroundImage:
            mode === 'light'
              ? 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)'
              : mode === 'dark'
                ? 'linear-gradient(135deg, #020617 0%, #111827 100%)'
                : 'radial-gradient(circle at top, rgba(56, 189, 248, 0.18), transparent 35%), radial-gradient(circle at right, rgba(168, 85, 247, 0.16), transparent 30%), linear-gradient(135deg, #050816 0%, #0f172a 100%)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow:
            mode === 'light'
              ? '0 8px 20px rgba(37, 99, 235, 0.08)'
              : mode === 'dark'
                ? '0 8px 20px rgba(0,0,0,0.2)'
                : '0 10px 30px rgba(56, 189, 248, 0.12)',
          overflow: 'hidden',
        },
      },
    },
  },
});

export const createAppTheme = (mode: ResolvedThemeMode) => {
  return createTheme(getDesignTokens(mode));
};
